var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',[(_vm.appLoading)?_c('div',[_c('div',{staticClass:"text-center fs-20 pt-100",style:({
            height: `100vh`,
          })},[_c('wtr-loader',{staticClass:"text-primary",attrs:{"loadingText":"Loading Page Content.....","addText":""}})],1)]):_vm._e(),(_vm.hasError)?_c('app-fail'):(_vm.canLoadApp)?_c('div',[_c('router-view')],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }